export const DOCUMENT_TYPES = {
  NEW_CUSTOMER_FORM: 'NEW_CUSTOMER_FORM',
  ONBOARDING_AUTH_FORM: 'ONBOARDING_AUTH_FORM',
  CREDIT_CHECK_SUMMARY: 'CREDIT_CHECK_SUMMARY',
  CREDIT_CHECK_DOCUMENTATION: 'CREDIT_CHECK_DOCUMENTATION',
  TEST: 'TEST',
}
